import { Upload, notification, Button, Icon } from "antd";
import * as React from "react";
import { UploadChangeParam, UploadProps } from "antd/lib/upload/interface";
import StandardButton from "../StandardButton/StandardButton";
import { ParagraphMedium } from "../Paragraphs/Paragraphs";
import Title from "../Title";
import "./PbrCertificateUploader.scss";

export interface IFileToUpload {
  name: string;
  file: string;
  type: string;
}

export default function PbrCertificateUploader(
  props: UploadProps & {
    onChangeBase64?: (fileToUpload: IFileToUpload) => void;
    btnText: string;
    title: string;
    subTitle?: string;
    btnOfficer?: boolean;
  }
) {
  const [imageUrl, setImageUrl] = React.useState("");
  const [fileName, setFileName] = React.useState("");

  function getBase64(file): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.toString() || "");
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  async function handleChange(info: UploadChangeParam) {
    try {
      const base64 = await getBase64(info.file);
      setImageUrl(base64);
      setFileName(info.file.name);
      if (props.onChangeBase64) {
        props.onChangeBase64({
          file: base64.split("base64,")[1],
          name: info.file.name,
          type: info.file.type
        });
      }
    } catch (error) {
      notification["error"]({
        message: "Erro ao carregar o arquivo",
        description: "Ocorreu um erro no carregamento do arquivo"
      });
      console.log(error);
    }
  }

  return (
    <>
      <Title size="h4" style={{ textAlign: "center" }}>
        <b>{props.title}</b>
      </Title>
      {props.subTitle && <ParagraphMedium>{props.subTitle}</ParagraphMedium>}
      <Upload
        className="doc-uploader"
        name="avatar"
        showUploadList={false}
        beforeUpload={(file, fileList) => false}
        onChange={info => handleChange(info)}
        action={() => null}
      >
        {imageUrl ? (
          <Icon type={`file-add`} style={{ fontSize: "64px" }} />
        ) : props.btnOfficer ? (
          <Button block style={{ height: "48px", margin: "30px 0" }}>
            {props.btnText}
          </Button>
        ) : (
          <StandardButton preset="outline" style={{ width: "100%" }}>
            {props.btnText}
          </StandardButton>
        )}
      </Upload>
      {imageUrl && (
        <div>
          <ParagraphMedium
            style={{
              textAlign: "center",
              color: "#777777",
              paddingTop: "3px",
              fontSize: "12px",
              paddingBottom: "0px"
            }}
          >
            {`${fileName}`}
          </ParagraphMedium>
          <ParagraphMedium
            style={{
              textAlign: "center",
              color: "#777777",
              paddingTop: "10px"
            }}
          >
            {`Clique no arquivo acima se desejar alterar o documento.`}
          </ParagraphMedium>
        </div>
      )}
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrCertificateUploader/PbrCertificateUploader.tsx